<template>
	<div>
		<!-- pc端 -->
		<header id="lib_top">
			<nav class="l_nav">
				<div class="vol_nav margin">
					<div class="top_l_nav">
						<a target="_blank" href="https://www.tunnelling.cn/Index.aspx" title="首页"><img src="../assets/img/top_logo.png" alt="logo"></a>
						<a href="https://www.tunnelling.cn/Index.aspx" class="hover" title="首页">首页</a>
						<a target="_blank" href="https://www.tunnelling.cn/PNews/News.aspx" title="资讯">资讯</a>
						<a target="_blank" href="https://www.tunnelling.cn/PVideo/Video.aspx" title="视频">视频</a>
						<a target="_blank" href="https://www.tunnelling.cn/PSpecial/Special.aspx" title="专题">专题</a>
						<a target="_blank" href="https://www.tunnelling.cn/PLibrary/PLibraryIndex.aspx" title="书馆">书馆</a>
						<a target="_blank" href="https://baike.tunnelling.cn/#/" title="隧道百科">隧道百科</a>
						<a target="_blank" href="https://www.tunnelling.cn/PSoftware/software.aspx" title="软件">软件</a>
						<a target="_blank" href="https://www.tunnelling.cn/PNews/WeChatList.aspx" title="微信">微信<i></i></a>
						<a target="_blank" href="https://www.tunnelling.cn/PEnjoyShare/DataBaseIndex.aspx" title="知享文库">知享文库</a>
						<a target="_blank" href="https://zhishi.tunnelling.cn/" title="知识平台">知识平台</a>
						<a target="_blank" href="https://www.tunnelling.cn/PIncubation/IncubationList.aspx" title="孵化园">孵化园</a>
						<a href="javascript:;">走进深隧<img src="../assets/img/QRcode.png"></a>
					</div>
					<div class="out_username" v-if="isLogin">
						<a href="javascript:;" class="r_but" title="注销" @click="PostSignOut">退出</a>
						<a href="https://www.tunnelling.cn/PMember/MemberIndex.aspx" class="l_but" :title="userName" target="_blank">{{userName}}</a>
						<router-link to="/myCart" class="my-cart l_but" target="_blank">购物车<span class="CartNum" v-if="cartNum">{{ cartNum }}</span></router-link>
					</div>
					<div class="top_r_nav" v-else>
						<a href="https://www.tunnelling.cn/PMember/MemberRegister.aspx" class="r_but" title="注册" target="_blank">注册</a>
						<span @click="GoLogin('login')" class="l_but" title="登录">登录</span>
						<span @click="GoLogin('cart')" class="my-cart" title="购物车">购物车<span v-if="cartNum">{{ cartNum }}</span></span>
					</div>
				</div>
			</nav>
			<!--menu-->
			<div class="lib_menu margin">
				<div class="logo">
					<a href=""><img src="../assets/img/knowledgeSerLogo.png" alt="知识服务"></a>
				</div>
				<div class="search radius6">
					<input class="inp_srh" name="keyboard" style="width: 220px;" placeholder="请输入搜索内容" v-model="searchTxt" @blur="CloseRecord"
					 @input="GetHistoricalRecords" @focus="OpenRecord" @keyup.enter="SearchRecord">
					<input class="btn_srh" type="button" name="submit" value="" @click="SearchRecord">
					<input type="text" style="display: none" value="无用的文本框（页面只有一个input type=text时 回车会提交）">
					<div class="selectBox" v-show="showRecords">
						<ul>
							<li v-for="(item,index) in HistoricalRecords" :key="index">
								<a :href="'https://www.tunnelling.cn/Search.aspx?searchContent='+item+'&iszs=true'" target="_blank">{{item}}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</header>
		<div class="clear" style="height: 106px;"></div>
		<!-- 移动端 -->
		<header id="knowledgeHead">
			<div class="HeadBox">
				<div class="left_head">
					<a href="https://m.tunnelling.cn/Index.aspx"><img src="../assets/img/Teclogo_icon.png" alt="" /></a>
					<router-link to="/index">知识服务 </router-link>
					<slot name="bookTitle"></slot>
				</div>
				<div class="right_head">
					<a href="javascript:;" @click="OpenSearch"></a>
					<router-link to="/myCart" class="my-cart" v-if="isLogin"><span v-if="cartNum">{{ cartNum }}</span></router-link>
					<a href="javascript:;" v-else class="my-cart" @click="GoLogin('cart')"></a>
					<a href="https://m.tunnelling.cn/Manager/MemberIndex.aspx" v-if="isLogin"><img :src="imgUrl" alt="" /></a>
					<a href="javascript:;" class="loginMob" @click="GoLogin('login')" v-else>登陆</a>
				</div>
			</div>
			<el-collapse-transition>
				<div class="header_search" id="divOne_1" v-show="isshowSearch">
					<a href="javascript:;" title="" @click="GoSearch"><i class="el-icon-search"></i></a>
					<input class="header_searchbox" type="text" name="textfield" id="textfield" v-model="searchTxt" placeholder="请输入搜索内容"
					 @keyup.enter="GoSearch">
					<input class="" type="text" name="textfield" style="display: none;" placeholder="请输入搜索内容">
				</div>
			</el-collapse-transition>
		</header>
		<!-- 弹框 -->
		<div id="promptwindow" v-if="isshowTip" style="height: auto; z-index: 9999; position: fixed; left: 50%; top: 50%; margin-top: -89px; margin-left: -220px;">
			<div class="promptwindow-tit">
				<a href="javascript:" style="float: right; font-size: 22px;" data-id="promptClose" id="close"><img src="../assets/img/icon_close.png">
				</a></div>
			<div class="promptwindow-content">
				<img src="../assets/img/icon_remind2.png" width="50" height="50" id="img">
				<p data-content="content">请输入搜索内容！</p>
				<p data-content="prompt"></p>
			</div>
			<div class="promptwindow-prompt">

			</div>
			<div class="promptwindow-foot" @click="ConfirmFn">
				<a href="javascript:" data-id="promptClose" data-type="quren">确 定</a>
				<a href="" data-type="add" style="display: none"></a>
				<a href="javascript:" data-type="quxiao" style="display: none;"></a>
			</div>
		</div>
	</div>
</template>

<script>
	import common from '../assets/js/common.js'
	export default {
		data() {
			return {
				isLogin: false, // 是否登录
				userName: '', // 用户名
				imgUrl: '', // 用户头像
				showRecords: false, // 是否显示历史记录
				HistoricalRecords: [], // 历史记录
				searchTxt: '', // 搜索的文本
				isshowTip: false, // 是否显示提示框
				isshowSearch: false, // 是否显示搜索框
				cartNum: 0  // 购物车数量
			}
		},
		mounted() {
			this.GetUserInfo();
			// 页面请求加入购物车成功后 触发获取购物车数量
			common.$on('getCartNum', () => {
				this.getCartNumFn()
			})
		},
		methods: {
			// 获取购物车数量
			getCartNumFn() {
				this.$fetch('/api/ShoppingCarts/count').then(res => {
					this.cartNum = res.data.count
				}).catch(err => {
					throw err;
				})
			},
			// 去登陆
			GoLogin(ispage) {
				let nowHref = ispage === 'login' ? location.href : `${Const_Api_Root}/#/myCart`;
				let href = 'https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=' + encodeURIComponent(nowHref);
				location.href = href;
			},
			// 退出
			PostSignOut() {
				this.$post('/Login/SignOut')
					.then((res) => {
						sessionStorage.removeItem('flag');
						let nowHref = '';
						if (this.$route.query.isPopup) {
							let url = location.href;
							nowHref = url.split('&');
						} else {
							nowHref = location.href;
						}
						let href = 'https://www.tunnelling.cn/logout.aspx?returnUrl=' + encodeURIComponent(nowHref);
						location.href = href;
					}).catch((err) => {
						throw err;
					});
			},
			// 获取用户信息
			GetUserInfo() {
				this.$fetch('/Login')
					.then((res) => {
						if (res.data.accessAllowed === false) {
							this.isLogin = false;
							return;
						}
						// 获取购物车数量
						this.getCartNumFn();
						// 用户信息
						this.userName = res.data.nickName;
						this.imgUrl = res.data.imagePath;
						this.isLogin = true;
					}).catch((err) => {
						throw err;
					});
			},
            // 获取登录状态
            getIsLoginVal() {
                return this.isLogin;
            },
			// mobile 打开搜索框
			OpenSearch() {
				this.isshowSearch = !this.isshowSearch;
			},
			// mobile 搜索
			GoSearch() {
				if (this.searchTxt == '') {
					this.$message({
						message: '请输入搜索内容！',
						type: 'warning'
					});
					return;
				}
				location.href = "https://m.tunnelling.cn/Search.aspx?searchInfo=" + this.searchTxt + "&iszs=true";
			},
			// 获取历史记录
			GetHistoricalRecords() {
				let data = {
					name: this.searchTxt
				};
				this.$axios.get('https://www.tunnelling.cn/ASHX/SearchRelevantKey.ashx?name=' + this.searchTxt, {
						withCredentials: false
					})
					.then((res) => {
						this.HistoricalRecords = res.data.KeyList;
					}).catch((err) => {
						throw err;
					});
			},
			// 获取热门
			GetHotList() {
				let data = {
					name: this.searchTxt
				};
				this.$axios.get('https://www.tunnelling.cn/ASHX/SearchHotKey.ashx?name=' + this.searchTxt, {
						withCredentials: false
					})
					.then((res) => {
						this.HistoricalRecords = res.data.KeyList;
					}).catch((err) => {
						throw err;
					});
			},
			// 搜索
			SearchRecord() {
				if (this.searchTxt == '') {
					this.isshowTip = true;
					return;
				}
				let href = 'https://www.tunnelling.cn/Search.aspx?searchContent=' + this.searchTxt + '&iszs=true';
				window.open(href, '_blank');
			},
			// 确定
			ConfirmFn() {
				this.isshowTip = false;
			},
			// 失去焦点 历史记录框消失
			CloseRecord() {
				setTimeout(() => {
					this.showRecords = false;
				}, 500);
			},
			// 获取焦点 历史记录打开
			OpenRecord() {
				this.showRecords = true;
				this.GetHotList();
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@media screen and (min-width: 320px) and (max-width: 1024px) {
		/* 购物车 */
		.right_head .my-cart {
			display: block;
			width: 24px;
			height: 24px;
			background: url(../assets/img/myCart_mobile.png) no-repeat center center;
			background-size: 100% 100%;
			margin: 0 15px 0 5px;
			position: relative;
		}
		
		.right_head .my-cart span {
			display: inline-block;
			width: 20px;
			height: 14px;
			line-height: 14px;
			background: #DB3838;
			border-radius: 27px;
			color: #FFFFFF;
			font-size: 10px;
			text-align: center;
			position: absolute;
			top: -3px;
			right: -11px;
		}
		/* 隐藏pc端 */
		#lib_top {
			display: none;
		}

		.clear {
			display: none;
		}

		/* mobile */
		#knowledgeHead {
			width: 100%;
			padding: 0 .2rem 0 0;
			box-sizing: border-box;
		}

		.HeadBox {
			display: flex;
			align-items: center;
			overflow: hidden;
		}

		.left_head {
			width: calc(100% - 2.1rem);
			display: flex;
			align-items: center;
		}

		.left_head a {
			color: #333333;
			font-size: .28rem;
			font-weight: normal;
		}

		.left_head a:first-child {
			width: 50px;
			height: 50px;
			text-align: center;
		}

		.left_head a img {
			height: 100%;
			width: auto;
		}

		.right_head {
			display: flex;
			align-items: center;
		}

		.right_head a {
			display: block;
			width: .6rem;
			height: .6rem;
		}

		.right_head a img {
			width: .6rem;
			height: .6rem;
			border-radius: 50%;
		}

		.right_head>a:first-child {
			background: url(../assets/img/searchAll_icon.svg) no-repeat center center;
			background-size: 100% 100%;
		}

		.right_head .loginMob {
			line-height: .6rem;
			text-align: center;
			color: #333333;
			font-size: .28rem;
		}

		/* mobile搜索框 */
		.header_search {
			height: 30px;
			line-height: 30px;
			margin-top: 7px;
			margin-right: 10px;
			margin-bottom: 7px;
			margin-left: 10px;
			border: 1px solid #dcdcdc;
			border-radius: 4px;
			padding-right: 10px;
			padding-left: 10px;
			font-size: 1.5em;
			color: #9c9c9c;
			background-color: #fff;
		}

		.header_search a {
			color: #9c9c9c;
			display: block;
			float: right;
		}

		.header_searchbox {
			height: 28px;
			width: 90%;
			float: left;
			color: #9c9c9c;
			font-size: 15px;
		}

		.iconfont {
			font-family: "iconfont" !important;
			font-style: normal;
			-webkit-font-smoothing: antialiased;
			-webkit-text-stroke-width: 0.2px;
			-moz-osx-font-smoothing: grayscale;
		}

		input[type="text"] {
			-webkit-appearance: none;
			appearance: none;
			outline: none;
			-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
			border-radius: 0;
			font-family: 'Arial', Microsoft YaHei;
		}
	}

	@media screen and (min-width: 1029px) {
		/* 购物车 */
		.my-cart {
			display: block;
			font-size: 14px;
			background: #EF8264 url(../assets/img/MyCart_pc.png) no-repeat 56px center;
			background-size: 16px 16px;
			padding-right: 28px;
			padding-left: 12px;
			height: 26px !important;
			line-height: 26px !important;
			position: relative;
			margin-right: 20px !important;
			color: #ffffff;
			border-radius: 49px;
			margin-top: 4px !important;
		}
		
		.my-cart span {
			display: inline-block;
			width: 20px;
			height: 14px !important;
			line-height: 14px !important;
			text-align: center;
			background: #DB3838;
			border-radius: 7px;
			font-size: 10px;
			position: absolute;
			top: -10px;
			right: -24px;
		}
		.my-cart .CartNum{
			display: inline-block;
			width: 20px;
			height: 14px !important;
			line-height: 14px !important;
			text-align: center;
			background: #DB3838;
			border-radius: 7px;
			font-size: 10px;
			position: absolute;
			top: -4px;
			right: -7px;
		}
		/* pc */
		#lib_top {
			position: fixed;
			height: 119px;
			top: 0;
			z-index: 990;
			background: url(../assets/img/menu_bg.png) left top repeat-x;
			margin: 0 auto;
			width: calc(100% - 14px);
			font-size: 14px;
		}

		.l_nav {
			height: 34px;
			background: #0078d7;
			overflow: hidden;
		}

		.l_nav .vol_nav {
			width: 1170px;
		}

		.margin {
			margin: 0 auto;
		}

		.l_nav .vol_nav .top_l_nav {
			float: left;
		}

		.l_nav .vol_nav .top_l_nav a {
			float: left;
			line-height: 34px;
			color: #ffffff;
			margin: 0px 5px;
			padding: 0px 5px;
		}

		.l_nav .top_r_nav a,
		.l_nav .top_r_nav span,
		.out_username a {
			float: right;
			height: 20px;
			line-height: 20px;
			color: #ffffff;
			text-align: center;
			margin-top: 6px;
			margin-right: 10px;
		}

		.l_nav .top_r_nav span {
			cursor: pointer;
		}

		.lib_menu {
			height: 85px;
			width: 1170px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: relative;
		}
		
		.l_nav .vol_nav .top_l_nav a:last-child:hover img {
		    display: block;
		}
		
		.l_nav .vol_nav .top_l_nav a:last-child img {
		    position: fixed;
		    width: 150px;
		    height: 150px;
		    top: 34px;
		    right: 39%;
		    display: none;
		    z-index: 999;
		}

		.selectBox {
			width: 240px;
			background: #FFFFFF;
			border: 1px solid #5897fb;
			border-radius: 4px;
			-webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, .15);
			box-shadow: 0 4px 5px rgba(0, 0, 0, .15);
			position: absolute;
			top: 60px;
			right: 7px;
		}

		.selectBox ul {
			margin: 5px 0px 5px 0px;
		}

		.selectBox ul li {
			clear: both;
			list-style: none;
			padding: 3px 7px 4px;
			cursor: pointer;
		}

		.selectBox ul li:hover {
			background: #DDDDDD;
			color: #FFFFFF;
		}

		.selectBox ul li:hover a {
			color: #FFFFFF;
		}

		.selectBox ul a {
			display: block;
		}

		.lib_menu .logo {
			/* width: 200px; */
			flex: 1;
			margin-left: 30px;
			margin-top: -10px;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.search {
			height: 35px;
			width: 255px;
			background-color: #f1f1f1;
			margin-top: -10px;
		}

		.search input.inp_srh {
			outline: none;
			width: 165px;
			font-family: "微软雅黑";
			font-size: 14px;
			text-indent: 1em;
		}

		.search input.inp_srh,
		.search input.btn_srh {
			border: none;
			background: none;
			height: 35px;
			line-height: 35px;
			float: left;
		}

		.search input.btn_srh {
			width: 35px;
			height: 35px;
			background: url(../assets/img/mainbg.png) -103px 8px no-repeat;
			cursor: pointer;
		}

		.clear {
			height: 0px;
			line-height: 0;
			font-size: 0;
			clear: both;
		}

		/* 隐藏移动端 */
		#knowledgeHead {
			display: none;
		}

		/* 弹框 */
		#promptwindow {
			width: 440px;
			height: 210px;
			background-color: #FFFFFF;
			line-height: 24px;
			position: relative;
			border-radius: 10px;
		}

		.promptwindow-tit {
			position: absolute;
			top: -10px;
			right: -10px;
		}

		.promptwindow-content {
			padding-top: 30px;
			padding-left: 10px;
			padding-right: 10px;
			overflow: hidden;
			text-align: center;
			font-size: 18px;
			color: #ef8609;
		}

		.promptwindow-prompt {
			text-align: center;
			font-size: 14px;
			color: #838486;
			padding-bottom: 20px;
			margin-top: 10px;
		}

		.promptwindow-foot {
			font-size: 14px;
			line-height: 38px;
			background-color: #f67b31;
			border-top-width: 1px;
			border-top-style: solid;
			border-top-color: #f0f0f0;
			text-align: center;
			height: 38px;
			border-radius: 0px 0px 10px 10px;
		}

		.promptwindow-foot a {
			display: inline-block;
			padding-right: 40px;
			padding-left: 40px;
			line-height: 30px;
			margin-top: 4px;
			border-radius: 3px;
			color: #fff;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/TopHeader.vue